import { Button, Divider, Flex, Modal } from 'antd'
import { useModalRequestsDelete } from 'src/pages/budget/budgetRequests/hooks'
import {
  closeModalRequestsDelete,
  deleteRequestsFx,
  reloadBudgetRequests,
} from 'src/pages/budget/budgetRequests/model'
import { UiText } from 'src/pages/budget/components'
import { showNotification } from 'src/features/notifications'

export const ModalRequestsDelete = () => {
  const modalRequestsDelete = useModalRequestsDelete()

  if (!modalRequestsDelete) return null

  const { items } = modalRequestsDelete
  const open = Boolean(modalRequestsDelete)

  const handleCancel = () => closeModalRequestsDelete()
  const handleOk = async () => {
    const results = await Promise.allSettled(
      items.map(({ id }) =>
        deleteRequestsFx({
          url: `/budget/budget_request/${id}`,
          body: { id: String(id) },
        }),
      ),
    )
    const failedIds = results.flatMap((result, index) => result.status === 'rejected' ? [items[index].id] : [])
    reloadBudgetRequests()
    showNotification({
      type: failedIds.length ? 'warning' : 'success',
      message: failedIds.length ? `Не удалены заявки №${failedIds.join(', ')}` : `Удалено заявок: ${items.length}`,
      description: failedIds.length ? 'Остальные выбранные заявки удалены.' : '',
    })
    closeModalRequestsDelete()
  }
  const ids = items.map(({ id }) => id)

  return (
    <Modal
      title={
        <div style={{ fontSize: 20 }}>
          Удалить {ids.length > 1 ? 'заявки' : 'заявку'}
        </div>
      }
      centered
      wrapClassName="ant_modal"
      width={500}
      maskClosable={false}
      open={open}
      destroyOnHidden
      onCancel={handleCancel}
      footer={
        <Flex gap={8}>
          <Button size="large" style={{ flex: 1 }} onClick={handleCancel}>
            Отменить
          </Button>
          <Button
            size="large"
            style={{ flex: 1 }}
            danger
            type="primary"
            onClick={handleOk}
          >
            Удалить
          </Button>
        </Flex>
      }
    >
      <Divider />
      <UiText size={18}>
        Вы уверены, что хотите удалить{' '}
        {ids.length > 1 ? 'заявки №' : 'заявку №'}
        <UiText size={18} strong>
          {' '}
          {ids.join(', ')}
        </UiText>
        ? Это действие нельзя будет отменить, и вам придется заново создавать
        заявку, если вы потом передумаете.
      </UiText>
      <Divider />
    </Modal>
  )
}
